<template>
  <van-empty :description="desc">
    <img class="err-img" src="~img/err.png" slot="image" />
  </van-empty>
</template>

<script>
import { Empty } from 'vant'

export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  components: {
    [Empty.name]: Empty
  },
  computed: {
    desc() {
      return this.text || this.$route.query.msg || '页面丢失了'
    }
  }
}
</script>
